import type { FC } from "react";
import { useMemo } from "react";

import type { ChipGroupItem } from "app/pages/sales-intelligence/common-components/filters-panel/components/ChipsGroup/ChipsGroup";
import ChipsGroup from "app/pages/sales-intelligence/common-components/filters-panel/components/ChipsGroup/ChipsGroup";
import type { IAppsSDKsFilterItem, SdkContentType } from "app/pages/sales-intelligence/domain/sdk/types/filter-values";
import { sdkContentTypeMap } from "app/pages/sales-intelligence/domain/sdk/types/filter-values";

type SdkChipsGroupProps = {
    sdk: IAppsSDKsFilterItem;
    onChangeSdk: (item: IAppsSDKsFilterItem) => void;
};

const SdkChipsGroup: FC<SdkChipsGroupProps> = ({ sdk, onChangeSdk }) => {
    const handleOnChipDelete = (item: ChipGroupItem) => {
        const { categories, sdks } = sdk;

        if (item.type === sdkContentTypeMap.category) {
            const updatedCategories = categories.includes(item.name)
                ? categories.filter((category: string) => category !== item.name)
                : [...categories, item.name];

            onChangeSdk({ ...sdk, categories: updatedCategories });
        }

        if (item.type === sdkContentTypeMap.sdk) {
            const updatedSdks = sdks.includes(item.name)
                ? sdks.filter((s: string) => s !== item.name)
                : [...sdks, item.name];

            onChangeSdk({ ...sdk, sdks: updatedSdks });
        }
    };

    const chipsData = useMemo(() => {
        const { categories, sdks } = sdk;
        const mappedCategories = categories.map((category: string) => {
            return {
                name: category,
                type: sdkContentTypeMap.category,
            };
        });

        const mappedSdks = sdks.map((s: string) => {
            return {
                name: s,
                type: sdkContentTypeMap.sdk,
            };
        });

        return [...mappedCategories, ...mappedSdks];
    }, [sdk]);

    return (
        <div>
            <ChipsGroup<SdkContentType>
                chipItems={chipsData}
                divider={sdk.operator}
                onDelete={handleOnChipDelete}
            />
        </div>
    );
};

export default SdkChipsGroup;
